module.exports = __webpack_public_path__ + "img/home.adf8db70.gif";